module.exports = __webpack_public_path__ + "media/images/Icon-desk-ea449e88a508416c176a372fe3a8a558.svg";